import type { Auth0UserProfile } from 'auth0-js';
import type { Organization } from 'types/api.types';

export type LaunchDarklyContext = Record<string, unknown>;

export const buildLaunchDarklyContext = ({
  profile,
  organization
}: {
  profile: Auth0UserProfile;
  organization?: Organization;
}): LaunchDarklyContext => {
  const email = profile.email;
  const user = {
    kind: 'user',
    key: profile.sub,
    anonymous: false,
    email,
    emailDomain: email?.split('@')[1],
    name: profile.name
  };

  if (!organization) return user;

  return {
    kind: 'multi',
    user,
    organization: {
      key: organization.id,
      name: organization.name,
      isSelfHostedK8s: !!organization.isSelfHostedK8s
    }
  };
};
